import { makeAutoObservable } from 'mobx';

class Auth {
  company = {
    tenantId: '',
    tenantName: '',
    code: '',
  }

  // 以下数据仅能用于埋点
  coverPoint = {

  }

  profile = {
    idNo: '',
    name: '',
  }

  features = {
    h5ResignationEnabled: false,
    h5ResignationLoaded: false,
  }

  isAuth = false

  constructor() {
    makeAutoObservable(this);
  }

  setIsAuth(isAuth) {
    this.isAuth = isAuth;
  }

  setCompany(company) {
    this.company = {
      ...this.company,
      ...company,
    };
  }

  setProfile(profile) {
    this.profile = {
      ...this.profile,
      ...profile,
    };
  }

  setFeatures(features) {
    this.features = {
      ...this.features,
      ...features,
    };
  }

  // 以下数据仅能用于埋点
  setCoverPoint(coverPoint) {
    this.coverPoint = {
      ...this.coverPoint,
      ...coverPoint,
    };
  }
}

export default new Auth();
